// Map Stripe subscription status strings to simplified categories
// Output: 'active' | 'error' | 'incomplete'
export type SimplifiedStatus =
  | "active"
  | "error"
  | "incomplete"
  | "unpaid"
  | "paused";

// Stripe subscription statuses as of 2024-2025 include:
// 'incomplete', 'incomplete_expired', 'trialing', 'active', 'past_due',
// 'canceled', 'unpaid', 'paused'
// We'll map these to the three buckets requested.
export function mapSubscriptionStatus(
  status?: string | null
): SimplifiedStatus {
  const s = (status || "").toLowerCase();
  // Clearly active states
  if (s === "active" || s === "trialing") return "active";
  if (s === "unpaid" || s === "past_due") return "unpaid";
  if (s === "paused") return "paused";

  // Incomplete states (setup not finished or expired)
  if (s === "incomplete" || s === "incomplete_expired") return "incomplete";

  // Error/problematic states
  if (s === "canceled" || s === "uncollectible") {
    return "error";
  }

  // Default to incomplete for unknown/empty values
  return "incomplete";
}
